import { ReactElement } from "react";
import { ReactionKind, ReactionUserModel } from "client/Api/Hub/common";
import { ensureNotNil, setTrackingId } from "client/Misc/utils";
import styles from "./List.module.less";
import { PersonAvatar } from "client/Components";
import { getComputedDisplayName } from "client/Features/AddressBook/common";
import { getUserProfileImageUrl } from "client/Api/UserProfile/service";
import { reactionIconMap } from "../ReactionsCountButton/ReactionsCountButton";
import { localize } from "client_legacy/ndaw/culture";

export type ListProps = {
	items: readonly ReactionUserModel[];
};

export const List = (props: ListProps): ReactElement => {
	const {
		items
	} = props;

	return (
		<ul {...setTrackingId("reactions-list")}>
			{items.map(x => (
				<li key={x.user.userId}>
					<Item reaction={x}/>
				</li>
			))}
		</ul>
	);
};
List.displayName="List";

type ItemProps = {
	reaction: ReactionUserModel;
};

const Item = (props: ItemProps): ReactElement => {
	const {
		reaction: {
			user,
			reactionKind
		}
	} = props;

	const profileImageUrl: string | null = user.avatarId
		? getUserProfileImageUrl(user.avatarId)
		: null;

	const {
		initials,
		computedDisplayName
	} = getComputedDisplayName({
		firstName: user.firstName,
		lastName: user.lastName
	});

	return (
		<div className={styles.item}>
			<div className={styles.avatar}>
				<PersonAvatar
					trackingId="avatar"
					initials={initials}
					imageSrc={profileImageUrl}
					status={{
						kind: "icon",
						icon: {
							kind: "svg",
							name: ensureNotNil(
								reactionIconMap[reactionKind]
							)
						},
						iconTitle: ensureNotNil(
							reactionNameMap[reactionKind]
						)
					}}
				/>
			</div>
			<div
				{...setTrackingId("display-name")}
				className={styles.name}
			>
				{computedDisplayName}
			</div>
		</div>
	);
};
Item.displayName="Item";

export const reactionNameMap: { [k in ReactionKind]: string | undefined; } = {
	[ReactionKind.NoReaction]: undefined,
	[ReactionKind.Like]: localize("_Like"),
	[ReactionKind.Celebrate]: localize("_Celebrate"),
	[ReactionKind.Laugh]: localize("_Laugh"),
	[ReactionKind.Love]: localize("_Love"),
	[ReactionKind.Sad]: localize("_Sad"),
	[ReactionKind.Thank]:localize("_Thank"),
};